<template>
  <main class="user">
    <div class="container">
      <div v-if="!loading">
        <div class="jumbotron"><h3>Ajoutez un nouveau compte</h3><hr/><userForm v-model="user" @submit="onAdd"/></div>
        <infoForm v-model="user" @toggle="onModal"/>
        <userList :objects="users" @show="onShow"/>
      </div>
      <loader v-else/>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

let userForm = {
  props: {
    value: Object,
    number: {
      type: Number,
      validator(value) {return value >= 0;}
    }
  },
  data() {
    return {types: ['Marchand','Accepteur','Officiel']}
  },
  computed: {
    checked: {
      get() {
        return this.value.owner.role === 'ADMIN'
      },
      set(e){
        this.value.owner.role = e?'ADMIN':'USER'
      }
    },
    localNumber: {
        get() {
            return this.number;
        }, set(value) {
            this.$emit('update:number', value); //<count-from-number :number="numberToDisplay" @update:number="val => numberToDisplay = val" />
        }
    },
  },
  methods: {
      onInput(e) {
        if(e.isValid && !this.value.no) this.value.owner.phone = e.country.dialCode + e.number ///@param {string} number @param {Boolean} isValid @param {string} country // Ex: inputted: (AU) 0432 432 432 => number = '+61432421546'
      },
  },
  template: `
  <form @submit.prevent="$emit('submit', value)">
    <div class="form-group"><input type="text" v-model="value.name" class="form-control" placeholder="Name"></div>
    <div class="form-group">
      <div class="form-row">
          <div class="col-md-6"><vue-tel-input @onInput="onInput" v-model="value.owner.phone" :disabledFormatting="true" :preferredCountries="['bj']"></vue-tel-input></div>
          <div class="col-md-6">
            <select class="form-control" v-model="value.type">
              <option disabled value="">Please select type</option>
              <option v-for="type, key in types" :value="type">{{ type }}</option>
            </select>
          </div>
      </div>
    </div>
    <div class="form-group">
      <div class="form-row">
          <div class="col-md-6"><input type="email" v-model="value.email" class="form-control"  placeholder="Email" required="true"></div>
          <div class="col-md-6"><div class="form-check">
            <label class="form-check-label" for="gridCheck">
              <input type="checkbox" class="form-check-input" v-model="checked">
              Activer le <a href="#">compte super</a> associé ?
            </label>
          </div></div>
        </div>
    </div>
    <div class="form-group">
      <input type="text" v-model="value.address" class="form-control" placeholder="Adresse">
    </div>
    <div class="form-group">
      <input type="text" v-model="value.code" class="form-control" placeholder="Code" autofocus>
    </div>
    <div class="form-group">
      <button type="submit" class="btn btn-outline-warning btn-lg">Create</button>
    </div>
  </form>
  `
};

let infoForm = {
  props: {
    value: Object
  },
  data() {
    return {modal: 'wallet'}
  },
  computed: {
    path() {
      return require('../../assets/img/logo.png')
    }
  },
  template: `
  <modal v-model="modal" @close="$emit('toggle', modal)">
    <h3 slot="header">Les détails du compte</h3>
    <div class="row">
      <div class="col-lg-6 col-xlg-3 col-md-6">
        <h3 class="card-title m-b-30">{{value.name}}</h3><i class="fa fa-phone"></i><small>{{value.no}}</small> <i class="fa fa-envelope"></i><small>{{value.email}}</small> <i class="fa fa-map-marker"></i><small>{{value.address}}</small><br/>
        <h4 class="m-t-40 display-6"><i class="fa fa-wallet"></i> {{value.solde}}</h4>
        <em class="card-subtitle m-b-30"><i class="fa fa-calendar-alt"></i> {{value.updatedAt || value.createdAt}}</em>
        <a href="javascript:void(0)" class="m-r-10"><img :src="path" alt="user" class="img-circle" width="50"></a>
        <a href="javascript:void(0)" class="m-r-10"><img :src="path" alt="user" class="img-circle" width="50"></a>
        <a href="javascript:void(0)" class="m-r-10"><img :src="path" alt="user" class="img-circle" width="50"></a>
        <a href="javascript:void(0)" class="m-r-10"><img :src="path" alt="user" class="img-circle" width="50"></a>
        <div class="clearfix"></div>
        <button type="button" class="btn btn-sm btn-outline-success m-t-40" v-if="value.active">Disable</button>
        <button type="button" class="btn btn-lg btn-outline-danger m-t-40" v-else>Enable</button>
      </div>
      <div class="col-lg-6 col-xlg-9 col-md-6 b-l p-l-0">
          <ul class="product-review">
              <li>
                  <span class="text-muted display-5"><i class="mdi mdi-emoticon-cool"></i></span>
                  <div class="dl m-l-10">
                      <h3 class="card-title">Solde</h3>
                      <h3 class="card-subtitle">{{value.solde}} IR</h3>
                  </div>
                  <div class="progress">
                      <div class="progress-bar bg-success" role="progressbar" style="width: 65%; height:6px;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
              </li>
              <li>
                  <span class="text-muted display-5"><i class="mdi mdi-emoticon-sad"></i></span>
                  <div class="dl m-l-10">
                      <h3 class="card-title">Devise</h3>
                      <h6 class="card-subtitle">{{value.devise}} $</h6>
                  </div>
                  <div class="progress">
                      <div class="progress-bar bg-danger" role="progressbar" style="width: 15%; height:6px;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
              </li>
              <li>
                  <span class="text-muted display-5"><i class="mdi mdi-emoticon-neutral"></i></span>
                  <div class="dl m-l-10">
                      <h3 class="card-title">Block</h3>
                      <h6 class="card-subtitle">{{value.block}} IR</h6>
                  </div>
                  <div class="progress">
                      <div class="progress-bar bg-primary" role="progressbar" style="width: 35%; height:6px;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
              </li>
          </ul>
      </div>
    </div>
  </modal>
  `
};

let userList = {
  props: {
    objects: Object
  },
  data() {
    return { keyword: '' }
  },
  methods: {
    filterBy(list,value){
      value = value.charAt(0).toUpperCase() + value.slice(1);
      return Object.values(list).filter(key => key.no.toString().indexOf(value) > -1)
    }
  },
  template: `
  <div>
    <input type="text" v-model="keyword" class="form-control mb-2" placeholder="Search by account number"/>
    <table class="table table-striped">
      <thead class="thead-light">
        <tr>
          <th scope="col">No</th>
          <th scope="col">Name</th>
          <th scope="col">Balance</th>
          <th scope="col">Type</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="obj in filterBy(objects,keyword)" :key="obj.id" @click.prevent="$emit('show', obj)">
          <th scope="row">{{obj.no}}</th>
          <td>{{obj.name}}</td>
          <td>{{obj.solde}}</td>
          <td>{{obj.type}}</td>
          <td><span :class="['badge badge-pill', obj.active ? 'badge-success' : 'badge-danger']">status</span></td>
        </tr>
      </tbody>
    </table>
  </div>
  `
};

export default {
  name: 'wallet',
  data() {
    return {loading: true, user: {type: '', owner: {}}}
  },
  computed: {
    ...mapGetters({users: 'resource/USERS'}),
  },
  methods: {
    ...mapActions('resource', ['insertUser','fetchUser','removeUser']),
    onAdd(value){
      this.loading = true;
      this.insertUser(value).then(() => {this.loading = false; this.user = {}});
    },
    onShow(value){
      this.user = { ...value };
      this.onModal('wallet')
    },
    onDrop(value){
      if(confirm(`Are you sure you want to delete ${value.id} ?`)) 
        this.removeUser(this.user);
    },
    onModal(value) {$(`#${value}`).modal('toggle')}
  },
  created() { this.fetchUser().then(() => this.loading = false); },
  components: {userForm, infoForm, userList}
}
</script>

<style scoped lang="scss"></style>
